// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"e87091d7","260":"af296618","464":"d7706c54","810":"9c6101be"}[chunkId] + ".chunk.css";
};